import { create } from 'zustand'
import { ProjectState } from '../types/project'

export const useProjectCreationStore = create<ProjectState>((set) => ({
  project: undefined,
  setProject: (project) =>
    set((state) => ({ project: { ...state.project, ...project } })),
  setFieldProject: (project) =>
    set((state) => ({
      project: { ...state.project, ...project },
      preventLeave: true,
    })),
  setPreventSave: (preventSave) => set(() => ({ preventSave })),
  setPreventLeave: (preventLeave) => set(() => ({ preventLeave })),
  resetProject: (project) => set(() => ({ project })),
  cleanErrors: () => set(() => ({ errors: [] })),
  addError: (error) =>
    set((state) => {
      const errors = state.errors || []
      const newErrors = errors
        .filter((e) => e.label !== error.label)
        .concat(error)
      return { errors: newErrors }
    }),
}))
